import { Provider } from '@vgtv/api-client';
import { Category, ConsentManager } from '@vgtv/consent-manager';
import { countryMap } from '../countryMap';

const getAllowlist = (provider: Provider): Category[] => {
  const providerCountry = Object.keys(countryMap).find((k) =>
    countryMap[k].includes(provider)
  );

  if (providerCountry === 'no') {
    return ['CMP:advertising', 'CMP:personalisation'];
  }

  return ['CMP:advertising'];
};

export const getConsentManager = (provider: Provider) => {
  return new ConsentManager({ allowlist: getAllowlist(provider) });
};
